/** Контракт SSR и клиента: под этим namespace лента рекомендаций под постом лежит в store */
export const getPostFeedNamespace = (postId: string) => `search-collection-${postId}`;
